function createElement(assetsToBeLoaded) {
  return assetsToBeLoaded.map(({ type, src, defer }) => {
    let element = {};
    return new Promise((resolve) => {
      switch (type) {
        case 'script':
          element = document.createElement('script');
          element.src = src;
          element.type = 'text/javascript';
          element.async = false;
          element.defer = defer;
          element.charset = 'UTF-8';
          element.onload = _elem => resolve(_elem);
          document.body.appendChild(element);
          break;
        case 'link':
          element = document.createElement('link');
          element.href = src;
          element.rel = 'stylesheet';
          element.async = false;
          element.defer = defer;
          element.onload = _elem => resolve(_elem);
          document.head.appendChild(element);
          break;
        default: break;
      }
    });
  });
}

export default async function injectRegistrationScripts() {
  const assetsToBeLoaded = [
    { type: 'link', src: '/assets/dest/css/intlInput.css?v=1', defer: false },
    { type: 'script', src: '/assets/src/js/inputValidator.js', defer: false },
    { type: 'script', src: 'https://storage.googleapis.com/clientaccess/registration/tz-moment.js', defer: false },
    { type: 'script', src: 'https://storage.googleapis.com/clientaccess/registration/IntlTelInput/intlTelInputUtils.js', defer: false },
  ];

  if ((document.getElementById('registration') || document.getElementById('demo-lead-register'))
    && !document.querySelector("script[src='/assets/src/js/inputValidator.js']")) {
    if (document.getElementById('registration')) {
      assetsToBeLoaded.push({
        type: 'script',
        src: '/assets/dest/js/registrationHelper-v4.js?v=36',
        defer: false,
      });
    }

    if (document.getElementById('demo-lead-register')
      && !document.querySelector("script[src='/assets/dest/js/demo-signup.js?v=35']")) {
      assetsToBeLoaded.push({
        type: 'script',
        src: '/assets/dest/js/demo-signup.js?v=35',
        defer: true,
      });
    }

    const isAppened = await Promise.all(createElement(assetsToBeLoaded)).then(() => true);
    return isAppened;
  }
  return true;
}

export async function injectDefaultScripts() {
  let assetsToBeLoaded = [];

  if (document.getElementById('trees-animation') && !document.querySelector("script[src='/assets/dest/js/trees.js?v=2']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/assets/dest/js/trees.js?v=2', defer: true }]);
  }

  if (document.getElementById('trustbox-widget') && !document.querySelector("script[src='//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', defer: true }]);
  }

  if (document.getElementById('agent-call-rec') && !document.querySelector("script[src='/assets/dest/js/audioPlayer-v1.js']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/assets/dest/js/audioPlayer-v1.js', defer: true }]);
  }

  if (document.getElementById('app-features-section') && !document.querySelector("script[src='/assets/dest/js/global-slider-functionalities-v3.js']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/assets/dest/js/global-slider-functionalities-v3.js', defer: true }]);
  }

  if (document.querySelector('.js-book') && !document.querySelector("script[src='/assets/dest/js/books.js']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/assets/dest/js/books.js', defer: true }]);
  }

  if (document.getElementById('videoPlayer') && !document.querySelector("script[src='/assets/dest/js/video-modal.js?v=9']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/assets/dest/js/video-modal.js?v=9', defer: true }]);
  }

  if (assetsToBeLoaded.length > 0) {
    const isAppened = await Promise.all(createElement(assetsToBeLoaded)).then(() => true);
    return isAppened;
  }
  return true;
}
